'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import Immutable from 'immutable';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import SortOptionsDropdown from './SortOptionsDropdown';
import InlineCurrentFilters from './InlineCurrentFilters';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import { getCategoryOptionText } from '../utils/langUtils';
export default createReactClass({
  displayName: "SortingBar",
  propTypes: {
    goodFilters: PropTypes.instanceOf(Immutable.Map).isRequired,
    numGoodsMatchingFilterCriteria: PropTypes.number.isRequired,
    onGoodFilterChange: PropTypes.func.isRequired,
    categoryFilter: PropTypes.string.isRequired
  },
  calculatePageRangeStart: function calculatePageRangeStart(page, limit, numGoodsMatchingFilterCriteria) {
    return numGoodsMatchingFilterCriteria === 0 ? 0 : page * limit + 1;
  },
  isLessThanOnePageOfResults: function isLessThanOnePageOfResults(limit, numGoodsMatchingFilterCriteria) {
    return numGoodsMatchingFilterCriteria < limit;
  },
  isOnLastPageAndPageIsNotFull: function isOnLastPageAndPageIsNotFull(page, limit, numGoodsMatchingFilterCriteria) {
    return numGoodsMatchingFilterCriteria < page * limit + limit;
  },
  calculatePageRangeEnd: function calculatePageRangeEnd(page, limit, numGoodsMatchingFilterCriteria) {
    if (this.isLessThanOnePageOfResults(limit, numGoodsMatchingFilterCriteria)) {
      return numGoodsMatchingFilterCriteria;
    } else if (this.isOnLastPageAndPageIsNotFull(page, limit, numGoodsMatchingFilterCriteria)) {
      return numGoodsMatchingFilterCriteria;
    }

    return page * limit + limit;
  },
  render: function render() {
    var _this$props = this.props,
        goodFilters = _this$props.goodFilters,
        numGoodsMatchingFilterCriteria = _this$props.numGoodsMatchingFilterCriteria,
        onGoodFilterChange = _this$props.onGoodFilterChange,
        categoryFilter = _this$props.categoryFilter;
    var limit = goodFilters.get(GoodFiltersAndPage.LIMIT);
    var page = goodFilters.get(GoodFiltersAndPage.PAGE);
    return React.createElement("div", null, React.createElement("h2", {
      className: "m-bottom-0 m-right-4"
    }, getCategoryOptionText(categoryFilter)), React.createElement(UIFlex, {
      justify: "between"
    }, React.createElement("div", {
      className: "m-top-2"
    }, React.createElement(FormattedHTMLMessage, {
      message: 'sortingBar.pageRange',
      options: {
        beginningOfPageRange: this.calculatePageRangeStart(page, limit, numGoodsMatchingFilterCriteria),
        endOfPageRange: this.calculatePageRangeEnd(page, limit, numGoodsMatchingFilterCriteria),
        totalNumberOfGoods: numGoodsMatchingFilterCriteria
      }
    }), React.createElement(InlineCurrentFilters, {
      goodFilters: goodFilters,
      onGoodFilterChange: onGoodFilterChange
    })), numGoodsMatchingFilterCriteria > 0 && React.createElement("div", null, React.createElement(SortOptionsDropdown, {
      onGoodFilterChange: onGoodFilterChange,
      sortingFilter: goodFilters.get(GoodFiltersAndPage.SORT_BY)
    }))));
  }
});